angular.module('qkr')
    .controller('KeyController', ['keyService', '$routeParams', '$scope', '$location', (keyService, $routeProvider,
        $scope, $location) => {

    $scope.currentKey = {};

	self.init = function() {
        // Console.log("init.keyId: "+$routeProvider.keyId);
        keyService.getKey($routeProvider.keyId).then((data) => {
            $scope.currentKey = data;
		});
	};

    $scope.renew = function() {
        // Console.log("renew");
        keyService.renewKey($scope.currentKey).then((data) => {
            $scope.currentKey = data;
            $location.url('/mastercard/keys');
        });
    };

    $scope.revoke = function() {
        // Console.log("update");
        keyService.revokeKey($scope.currentKey).then(() => {
            $location.url('/mastercard/keys');
        });
    };

    self.init();
}]);



// WEBPACK FOOTER //
// ./src/controllers/mastercard/key.controller.js